<template>
    <jb-buttons no-wrap>
        <jb-button color="success" class="buttons" :icon="mdiAccountCheck" title='Extracuricular Attendance' small @click="openAttendance"  v-if="this.params.data.dataType === 'excul'" />
        <jb-button color="warning" class="buttons" :icon="mdiMagnify" small @click="showDetail" />
        <jb-button color="success" class="buttons" :icon="mdiCircleEditOutline" small @click="editClass"  v-if="this.params.data.state ? (
            (this.params.data.state == 'Draft' || this.params.data.state == 'Waiting for Approval' || this.params.data.state == 'Contract' || this.params.data.state == 'Permanent')
        && (checkUser || !checkUser) ) : (checkUser)" />
        <jb-button color="danger" class="buttons" :icon="mdiTrashCan" small @click="deleteAction" v-if="this.params.data.state ? (
            (this.params.data.state == 'Draft' || this.params.data.state == 'Waiting for Approval' || this.params.data.state == 'Contract' || this.params.data.state == 'Permanent')
        && (checkUser || !checkUser) ) : (checkUser)" />
        <jb-button v-if="'is_compulsory' in this.params.data" color="info" class="buttons" :icon="mdiAccount" small @click="addTeacher" />
        <jb-button v-if="'teacher_role_id' in this.params.data" color="info" class="buttons" :icon="mdiAccount" small @click="jobdesk" />
        <jb-button v-if="'is_graduate' in this.params.data" color="info" class="buttons" :icon="mdiAccount" small @click="graduatePromotion" />
        <jb-button color="info" class="buttons" :icon="mdiContentCopy" small @click="copyClass" v-if="this.params.data.is_pricegroup" />
        <jb-button color="purple" class="buttons" :icon="mdiTextBoxSearch" small @click="viewFile()"  v-if="this.params.data.file_name || this.params.data.file" />
        <jb-button color="warning" class="buttons" :icon="mdiAccountAlert" title='Approve Termination' small @click="terminateAction"  v-if="this.params.data.table_name === 'tr_hr_punishment'
        && this.params.data.punishment_type_code === 'TERM'
        && this.params.data.is_active === 1" />
        <jb-button color="info" class="buttons" :icon="mdiCalendarEdit" title='insert subject score' small @click="addRegulerSubjectAction"  v-if="this.params.data.table_name === 't_lesson_plan'
        || this.params.data.table_name === 't_lesson_plan_session'" />
        <jb-button color="info" class="buttons" :icon="mdiDownloadCircleOutline" title='Download Lesson Plan' small @click="downloadLesson"  v-if="this.params.data.table_name === 't_lesson_plan'" />
    </jb-buttons>
</template>
<script>
    import JbButtons from '@/components/JbButtons'
    import JbButton from '@/components/JbButton'
    import { mdiCircleEditOutline, mdiTrashCan, mdiMagnify, mdiAccount, mdiContentCopy, mdiTextBoxSearch, mdiAccountAlert, mdiCalendarEdit, mdiDownloadCircleOutline, mdiAccountCheck } from '@mdi/js'
    import CryptoJS from 'crypto-js'
    import {
        onMounted,
        ref
    } from '@vue/runtime-core'

    export default {
        name: 'ButtonActionRender',
        components: {
            JbButtons,
            JbButton
        },
        setup (props) {
            const userRole = localStorage.getItem('roles')
            const checkUser = ref(false)
            const userCheck = async () => {
                if (userRole !== null) {
                    const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
                    const myArray = decryptedMessage.split(',')
                    for (let i = 0; i < myArray.length; i++) {
                        if ((myArray[i] === 'ROLE_ADMIN') || (myArray[i] === 'ROLE_ADMIN_HRD') || (myArray[i] === 'ROLE_HOMEROOM') || (myArray[i] === 'ROLE_ADMIN_FINANCE')) {
                            checkUser.value = true
                        }
                    }
                }
            }
            onMounted(() => {
                userCheck()
            })
            return {
                mdiCircleEditOutline,
                mdiTrashCan,
                mdiAccount,
                mdiContentCopy,
                mdiMagnify,
                mdiTextBoxSearch,
                mdiAccountAlert,
                mdiAccountCheck,
                mdiCalendarEdit,
                mdiDownloadCircleOutline,
                userRole,
                checkUser,
                userCheck
            }
        },

        methods: {
            showDetail (event) {
                // the grid component can now be accessed via this.params.context.componentParent
                this.params.context.componentParent.detailData(event, this.params.data, false, this.params.data.id)
            },
            editClass (event) {
                // the grid component can now be accessed via this.params.context.componentParent
                this.params.context.componentParent.editData(event, this.params.data, this.params.data.id)
            },
            copyClass (event) {
                // the grid component can now be accessed via this.params.context.componentParent
                this.params.context.componentParent.copyData(event, this.params.data)
            },
            deleteAction () {
                this.params.context.componentParent.deleteModalShow(this.params.value, this.params.data)
            },
            addTeacher () {
                this.$router.push('/teacherextracuricular')
            },
            jobdesk (event) {
                this.params.context.componentParent.teacherJobdesk(event, this.params.data)
            },
            graduatePromotion () {
                this.$router.push('/promotion')
            },
            viewFile (event) {
                this.params.context.componentParent.viewFile(event, this.params.value)
            },
            terminateAction (event) {
                this.params.context.componentParent.terminateData(event, this.params.value, this.params.data)
            },
            addRegulerSubjectAction (event) {
                this.params.context.componentParent.addRegulerSubject(this.params.data)
            },
            downloadLesson (event) {
                this.params.context.componentParent.downloadLessonPlan(this.params.data)
            },
            openAttendance (event) {
                this.params.context.componentParent.exculAttendance(this.params.data)
            }
        }

    }
</script>
